module.exports = __webpack_public_path__ + "img/9_96.b3877099.png";